import React from "react";
import "./index.scss";

interface SelectValue {
    label: React.ReactNode;
    value: any;
    id?: string
}

interface Props {
    defaultValue?: any;
    onValueSelect?: (selectedValue: string) => void;
    items: SelectValue[];
}

/*
    Це вибір між табами меню.
    Виніс в окремий компонент, щоб було зручніше ним користуватись
*/

export const Select = ({items, defaultValue, onValueSelect}: Props) => {

    const onItemSelect = (value: any) => {
        if (onValueSelect) {
            onValueSelect(value);
        }
    };

    return (
        <div className={"select-travel"}>
            {items.map((item, index) => {
                return (
                    <div id={'buyFirstTime_' + index} key={item.value}
                         className={`select-travel__item ${item.value === defaultValue ? 'select-travel__item_active' : ''}`}
                         onClick={() => onItemSelect(item.value)}>
                        <span className={"select-travel__item__label"}>{item.label}</span>
                    </div>
                )
            })}
        </div>
    )
};